import { theme } from "../../config/theme";

const styles = {
  healthCheckIcon: {
    height: "20px",
    marginRight: "12px"
  },
  high: {
    fill: `${theme.palette.health.green}`
  },
  medium: {
    fill: `${theme.palette.health.orange}`
  },
  low: {
    fill: `${theme.palette.health.yellow}`
  },
  percent: {
    display: "flex",
    alignItems: "center"
  }
};

export { styles };
